<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-input
        :disabled="!isedite"
        :style="inputStyle"
        type="text"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @keyup.enter.native="handleEnter"
        @blur="handleBlur"
        @focus="focus"
      />
    </el-tooltip>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'

export default {
  name: 'jtIdCard',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    types: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    _validate(value) {
      const errMsg = this.$t('idcard.INCORRECT_IDCARD_FORMAT', {
        idcard: value,
      })
      let types = this.types
      if (types == 'idcardGlobal' || types == 'idcardUnique' || types == 'idcardUnique2') {
        if (value.length >= 15) {
          Validator.isIdCard(value, errMsg)
        }
      } else {
        Validator.isIdCard(value, errMsg)
      }
    },
    _save() {
      let types = this.types
      let olidCardOld = this.value
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this._validate(value)
        this.val = value
      }
      
      if ((types == 'idcardUnique' || types =='idcardChnUnique' ) && olidCardOld !== value) {
        let config = storage.getItem(constants.GLOBAL_CONFIG)
        let { gameId, teamId } = config
        
        this.$emit('IDCheck', {
          gameId,
          teamId,
          olidCardOld,
          value: value.toUpperCase(),
        })
        // let data = await PageModel.IDCheck(gameId, teamId, olidCardOld, value)
        // if (data.errNo == 0) {
        //   this.$emit('datas', null, value.toUpperCase())
        // } else {
        //   tip(data.errMsg)
        // }
      } else {
        this.$emit('datas', null, value.toUpperCase())
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
